module.exports = __webpack_public_path__ + "static/img/1810_5.cd9de76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1810_5.jpg
// module id = 908K
// module chunks = 1